var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { DragDropContext, Draggable, Droppable, } from "react-beautiful-dnd";
import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@material-ui/core";
import { Delete, DragIndicator } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { usePlayerTrackId } from "frontend/src/domain/player-track-queue";
import { useAudio } from "frontend/src/domain/audio";
var useStyles = makeStyles(function (theme) { return ({
    dragHandleIcon: {
        fill: grey[500],
    },
    tr: {
        background: theme.palette.background.paper,
        "& td:nth-of-type(1), td:nth-of-type(2), td:nth-of-type(7)": {
            width: "5%",
        },
        "& td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5)": {
            width: "25%",
        },
        "& td:nth-of-type(6)": {
            width: "10%",
        },
        "&.Mui-selected, &.Mui-selected:hover": {
            background: theme.palette.action.hover,
        },
        "&[data-is-dragging='true']": {
            background: theme.palette.action.selected,
        },
    },
}); });
export var ReOrderPlaylistTracksTable = React.memo(function (_a) {
    var entries = _a.entries, onTrackMove = _a.onTrackMove, onTrackPause = _a.onTrackPause, onTrackPlay = _a.onTrackPlay, onTrackRemove = _a.onTrackRemove;
    var playerTrackId = usePlayerTrackId();
    var audio = useAudio();
    var onDragEnd = function (result) {
        var _a;
        if (typeof ((_a = result === null || result === void 0 ? void 0 : result.destination) === null || _a === void 0 ? void 0 : _a.index) === "number") {
            onTrackMove(result.source.index, result.destination.index);
        }
    };
    return (React.createElement(DragDropContext, { onDragEnd: onDragEnd },
        React.createElement(Droppable, { droppableId: "droppable" }, function (provided) { return (React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, null),
                        React.createElement(TableCell, null, null),
                        React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                        React.createElement(TableCell, null, "\u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C"),
                        React.createElement(TableCell, null, "\u0416\u0430\u043D\u0440\u044B"),
                        React.createElement(TableCell, null, "\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C"),
                        React.createElement(TableCell, null, null))),
                React.createElement(TableBody, __assign({}, provided.droppableProps, { ref: provided.innerRef }),
                    entries.map(function (_a, index) {
                        var id = _a.id, track = _a.track;
                        return (React.createElement(Draggable, { key: id, draggableId: id, index: index }, function (provided, snapshot) {
                            var selected = playerTrackId === track.id;
                            var playing = selected && audio.playing;
                            var loading = false;
                            return (React.createElement(Row, { index: index, selected: selected, playing: playing, loading: loading, provided: provided, snapshot: snapshot, track: track, onRemove: onTrackRemove, onPlay: onTrackPlay, onPause: onTrackPause }));
                        }));
                    }),
                    provided.placeholder)))); })));
});
var Row = React.memo(function (_a) {
    var index = _a.index, selected = _a.selected, loading = _a.loading, playing = _a.playing, snapshot = _a.snapshot, provided = _a.provided, _b = _a.track, title = _b.title, track = __rest(_b, ["title"]), onRemove = _a.onRemove, onPlay = _a.onPlay, onPause = _a.onPause;
    var classes = useStyles();
    var remove = function () { return onRemove(index); };
    var play = function () { return onPlay({ index: index, selected: selected }); };
    var genres = track.type === "public"
        ? track.genres.map(function (genre) { return genre.title; }).join(", ")
        : "Рекламный ролик";
    var artist = track.type === "public" ? track.artist : "";
    var duration = track.duration.formatted;
    return (React.createElement(TableRow, __assign({ className: classes.tr, innerRef: provided.innerRef, "data-is-dragging": snapshot.isDragging }, provided.draggableProps, { selected: selected }),
        React.createElement(TableCell, __assign({}, provided.dragHandleProps),
            React.createElement(Box, { display: "flex", alignItems: "center" },
                React.createElement(DragIndicator, { fontSize: "small", className: classes.dragHandleIcon }))),
        React.createElement(TableCell, null,
            React.createElement(AudioControlButton, { isLoading: loading, onPause: onPause, onPlay: play, isPlaying: playing })),
        React.createElement(TableCell, null, title),
        React.createElement(TableCell, null, artist),
        React.createElement(TableCell, null, genres),
        React.createElement(TableCell, null, duration),
        React.createElement(TableCell, null,
            React.createElement(IconButton, { size: "small", onClick: remove },
                React.createElement(Delete, null)))));
});
